module.exports = __webpack_public_path__ + "static/media/logo-porter.36c0403e.svg";